import * as Yup from 'yup'

export const quantityTypeValidation = (withQuantity: boolean) =>
  Yup.lazy((value) => {
    switch (typeof value) {
      case 'object':
        return withQuantity
          ? Yup.object().nullable().required('validation-required')
          : Yup.object().notRequired().nullable()
      case 'string':
        return withQuantity
          ? Yup.string()
              .nullable()
              .required('validation-required')
              .max(100, 'validation-quantity-type-max')
          : Yup.string().notRequired().nullable()
      default:
        return Yup.mixed()
    }
  })

export const impactSchema = (withQuantity: boolean) =>
  Yup.object().shape({
    name: Yup.string()
      .min(2, 'validation-name-min')
      .max(100, 'validation-name-max')
      .nullable()
      .required('validation-required'),
    code: Yup.string().max(100, 'validation-item-code-max').required('validation-required'),
    quantity: withQuantity
      ? Yup.string()
          .max(100, 'validation-quantity-type-max')
          .nullable()
          .required('validation-required')
      : Yup.string().max(100, 'validation-quantity-type-max').nullable(),
    quantity_type: quantityTypeValidation(withQuantity),
    period: withQuantity
      ? Yup.object().nullable().required('validation-required')
      : Yup.object().nullable(),
    period_start: withQuantity
      ? Yup.date().typeError('validation-date-invalid').nullable().required('validation-required')
      : Yup.object().nullable(),

    description: Yup.string().optional().nullable(),
    image: Yup.object().shape({
      icon: Yup.string().nullable(),
    }),
    media: Yup.array()
      .of(
        Yup.object().shape({
          title: Yup.string().nullable(false).required('validation-required'),
        }),
      )
      .optional(),
    products: Yup.string(),
  })
